import React, {useState} from "react";
import { useSelector} from 'react-redux';
import { Form, Field } from 'react-final-form'
import EmailFormField from "./EmailFormField";
import {sendUserMessage} from '../../../app/common/services/fetch.service';

const formFields = [
    {name: "email", placeHolder: "Твоят имейл" },
    {name: "subject", placeHolder: "Тема" },
    {name: "message", placeHolder: "Съобщение" },
]

const validateEmail = (value) => {
  return value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) 
        ?  'Невалиден имейл адрес'
        : undefined;
}

const validate = (values) => {
    const errors = {};

    formFields.forEach(({ name}) => {
        if (!values[name] ) {
            errors[name] = `Полето е задължително`;
        }

        if(values[name] && name === 'email') {
            errors[name] = validateEmail(values[name])
        }
    });

    return errors;
}


const ContactUs = ({show, toggleContactFormBox}) => {

    const auth = useSelector(state=>state.auth);
    const userDetails = useSelector(state=>state.userDetails);
    const {mobTelephone} = userDetails;
    
    const [contactResultBox, setContactResultBox] = useState(false);
    const [contactResultBoxFailed, setContactResultBoxFailed] = useState(false);

    const closeResultBox = () => setContactResultBox(false);

    const closeResultBoxFailed = () => setContactResultBoxFailed(false);

    const onSubmit = async (values, form) => {
        let phoneNumber = '';
        let prefMedia = 'MAIL';

        if(auth?.loginToken) {
            phoneNumber = mobTelephone;
            prefMedia = 'PHONE'
        }

        const data = {...values, phoneNumber, prefMedia};

        let res;

        try {
            res = await sendUserMessage(data);

        } catch (error) {console.log(error)}

        if(res?.data && res.data.status === 0) {
            form.restart();
            setContactResultBox(true);
            toggleContactFormBox();
            
        } else {
            setContactResultBoxFailed(true);
        }
    }    

    const renderFormFields = () => {

        return formFields.map(({placeHolder, name}, i) => {
    
            return <div  key={i+1} >
                    <Field 
                        type='text'
                        name={name}
                        label={placeHolder}
                        component={ EmailFormField } />   
                </div>             
        });
    }

    return <>
        <div className={"contact-box " + (show ? 'show-main' : 'hide')}>
            <div className="header">
                <div className="wrapper">
                    <figure className="logo">
                        <img src="/img/logo-dark.png" alt="Nu INS logo"></img>
                    </figure>
                    <span className="close" onClick={toggleContactFormBox}></span>
                </div>
            </div>
            <div className="form">
                <span className="close" onClick={toggleContactFormBox}></span>
                <Form
                    onSubmit={onSubmit}
                    validate={validate}
                    render={({ handleSubmit, form, submitting, pristine }) => (
                    <form onSubmit={handleSubmit}>
                        <h2>Ние сме тук, за да отговорим на твоите въпроси</h2>
                        <div className="nuins-mail">
                            <i className="icon icon-mail"></i> <span>help@nuins.io</span>
                        </div>

                        {renderFormFields()}
                  
                        <input type="submit" value="Изпрати съобщението" 
                                name="submit"
                                style={{marginTop: '40px'}}
                                disabled={submitting || pristine}></input>
                    </form>
                     )}
                />
            </div>
        </div>

        <div className={"contact-box-result " + (contactResultBox ? 'show-main' : 'hide')}>
            <div className="wrapper">
                <figure className="success">
                    <img src="/img/mark.png" alt=""></img>
                </figure>
                <h2>Твоето съобщение е изпратено успешно.</h2>
                <button onClick={closeResultBox} className="close">
                    <span>OK</span>
                </button>
            </div>
        </div>
        <div className={"contact-box-result " + (contactResultBoxFailed ? 'show-main' : 'hide')}>
            <div className="wrapper">
                <h2>Съобщението не беше изпратено, моля опитайте по късно </h2>
                <button onClick={closeResultBoxFailed} className="close">
                    <span>OK</span>
                </button>
            </div>
        </div>
    </>
}

export default ContactUs;

/*
{ false ? <>
    <div className="file-upload">
        <input type="file" name="file" ref={this.fileInput} onChange={this.onFileChange}></input>
        <div className="button" style={{width: "50%"}}>
            <div className="wrapper">
                <div className={"upload " + (this.state.buttonUpload ? 'show-main' : 'hide')} onClick={this.fileInputClick}>
                    <i className="icon icon-upload"></i>
                    <span>
                        Прикачи файл
                    </span>
                </div>
                <div className={"change " + (this.state.buttonChange ? 'show-main' : 'hide')} onClick={this.fileInputClick}>
                    <i className="icon icon-edit"></i>
                    <span>
                        Редактирай
                    </span>
                </div>
            </div>
        </div>
        <div className="uploaded">
            <div className={"wrapper " + (this.state.fileNamecontainer ? 'show-main' : 'hide')} >
                <span>{this.state.labelImportMsg}</span>
            </div>
        </div>
    </div> 
    </> : null}
    */